import { useTopBarHeight } from "./userTopBarHeight";
import { useIsTopBarHidden } from "./useIsTopBarHidden";

// Sub-headers stick just below the navbar. When the navbar slides out of view
// (hybrid sticky behavior), the sub-header translates up by the navbar height
// so it moves in lockstep with the navbar's slide instead of leaving a gap.
// Uses transform (not `top`) to match the navbar's transform-based slide and
// keep the animations synchronised.
export function useSubHeaderScroll() {
  const topBarHeight = useTopBarHeight().get();
  const isTopBarHidden = useIsTopBarHidden();

  return {
    stickyTop: `${topBarHeight}px`,
    stickyTransform: isTopBarHidden
      ? `translateY(-${topBarHeight}px)`
      : "translateY(0)",
    stickyTransition: "transform 0.1s ease-out",
  };
}
